
import logoImg from '../../imagens/LOGO.jpg';
import { NavLink, useLocation, useNavigate, Link } from 'react-router-dom';
import { FiUsers, FiSettings, FiDollarSign, FiShoppingCart, FiMenu, FiX, FiFile, FiFileText } from 'react-icons/fi';
import { BsBank } from "react-icons/bs";
import { MdOutlinePaid } from "react-icons/md";
import React, { useState, useEffect, useRef, useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';


import styles from './header.module.css';
import { toAbsoluteUrl } from "../../utils/assetUrl";

export default function Header() {
    const { user } = useContext(AuthContext);
    const [heademostrarFormulario, setHeadeMostrarFormulario] = useState(false);
    const [paginaAtiva, setPaginaAtiva] = useState('');
    const [isMobile, setIsMobile] = useState(() => {
        try { return window.matchMedia('(max-width: 767px)').matches; } catch { return false; }
    });
    const [destino, setDestino] = useState('');
    const menuBtnRef = useRef(null);
    const navRef = useRef(null);
    const location = useLocation();
    const navigate = useNavigate(); // Hook para navegação programática

    useEffect(() => {
        // Extrai o nome da página do pathname (ex.: "/Vendas" -> "Vendas")
        const paginaAtual = location.pathname.split('/').pop() || 'Home'; // Usa 'Home' como padrão
        setPaginaAtiva(paginaAtual);
        // console.debug('Página ativa:', paginaAtual);
    }, [location]); // Atualiza quando a localização muda

    // Observa largura da tela para tratar comportamento mobile/desktop
    useEffect(() => {
        const mql = window.matchMedia('(max-width: 767px)');
        const onChange = (e) => setIsMobile(e.matches);
        try {
            mql.addEventListener('change', onChange);
        } catch {
            // Safari fallback
            mql.addListener(onChange);
        }
        return () => {
            try { mql.removeEventListener('change', onChange); } catch { mql.removeListener(onChange); }
        };
    }, []);

    // Fecha menu com ESC quando aberto (apenas mobile)
    useEffect(() => {
        if (!isMobile || !heademostrarFormulario) return;
        const onKey = (e) => { if (e.key === 'Escape') setHeadeMostrarFormulario(false); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [isMobile, heademostrarFormulario]);

    // Bloqueia scroll do body quando menu mobile está aberto
    useEffect(() => {
        if (isMobile && heademostrarFormulario) {
            document.body.classList.add('no-scroll');
        } else {
            document.body.classList.remove('no-scroll');
        }
        return () => document.body.classList.remove('no-scroll');
    }, [isMobile, heademostrarFormulario]);

    const navegarHome = () => {
        setPaginaAtiva('Dashboard');
        setDestino('Dashboard');
        navigate('/Dashboard');
    };

    const headtoggleFormulario = () => {
        if (heademostrarFormulario) {
            // prestes a fechar: se foco está dentro do nav, devolver ao botão
            const navEl = navRef.current;
            if (navEl && navEl.contains(document.activeElement)) {
                try { document.activeElement.blur(); } catch {}
                menuBtnRef.current?.focus?.();
            }
        }
        setHeadeMostrarFormulario(!heademostrarFormulario);
    };

    const paginacao = () => {
        setHeadeMostrarFormulario(false)
    }

    // Ao abrir o menu (mobile), focar o primeiro item; ao fechar, devolver foco ao botão
    useEffect(() => {
        if (isMobile && heademostrarFormulario) {
            const id = window.requestAnimationFrame(() => {
                const nav = document.getElementById('main-nav');
                const first = nav?.querySelector('a, button');
                if (first && typeof first.focus === 'function') first.focus();
            });
            return () => window.cancelAnimationFrame(id);
        } else {
            menuBtnRef.current?.focus?.();
        }
    }, [isMobile, heademostrarFormulario]);


    return(
        <header className={styles.sidebar} role="banner">
            <div className={styles['header-side']}>
                <div className={styles.logo}>
                    <button
                        className={styles.svgmenuinicio}
                        onClick={headtoggleFormulario}
                        aria-label={heademostrarFormulario ? 'Fechar menu' : 'Abrir menu'}
                        aria-expanded={heademostrarFormulario}
                        aria-controls='main-nav'
                        ref={menuBtnRef}
                        type="button"
                    >
                        {heademostrarFormulario ? <FiX size={24}/> : <FiMenu size={24}/>}           
                    </button>
                    <Link
                onClick={navegarHome}
                to="/Dashboard" // Define a rota fixa ou usa o estado destino
                className={styles.svginicio}
            >
                <img
                    src={toAbsoluteUrl(user?.photoUrl) || logoImg}
                    onError={(e)=>{ e.currentTarget.onerror=null; e.currentTarget.src=logoImg; }}
                    alt="Logo / Perfil"
                    style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                        marginRight: '10px',
                    }}
                />
            </Link>
                    {/*<Link to='Dashboard' className='svginicio'>
                        <img className='imglogo' src={logoImg} alt="Logo do Sistema"/>                   
                    </Link>*/}
                </div>
        
                <nav
                    id='main-nav'
                    className={`${styles['heade-icnones']} ${heademostrarFormulario ? styles.active : ''}`}
                    role="navigation"
                    aria-label="Navegação principal"
                    aria-hidden={isMobile && !heademostrarFormulario}
                    ref={navRef}
                    {...(isMobile && !heademostrarFormulario ? { inert: '' } : {})}
                > 
                    
                    <NavLink to="/Vendas" className={styles.svgoutros} onClick={paginacao}>
                        <FiDollarSign size={24} />
                        Vendas
                    </NavLink>
                    <NavLink to="/Clientes" className={styles.svgoutros} onClick={paginacao}>
                        <FiUsers size={24} />
                        Clientes
                    </NavLink>
                    <NavLink to="/Caixa" className={styles.svgoutros} onClick={paginacao}>
                        <MdOutlinePaid size={24} />
                        Caixa
                    </NavLink>
                    <NavLink to="/Banco" className={styles.svgoutros} onClick={paginacao}>
                        <BsBank size={24} />
                        Banco
                    </NavLink>

                    <NavLink to="/Despesas" className={styles.svgoutros} onClick={paginacao}>
                        <FiShoppingCart size={24} />
                        Despesas
                    </NavLink>
                    
                    <NavLink to="/Notafiscal" className={styles.svgoutros} onClick={paginacao}>
                        <FiFile size={24} />
                        NFS
                    </NavLink>
                    
                    <NavLink to="/Financeiro" className={styles.svgoutros} onClick={paginacao}>
                        <FiSettings size={24} />
                        Financeiro
                    </NavLink>
                    <NavLink to="/IN1888" className={styles.svgoutros} onClick={paginacao}>
                        <FiFileText size={24} />
                        IN1888
                    </NavLink>
                    {/* Backdrop para mobile */}
                    {isMobile && heademostrarFormulario && <div className={styles['header-backdrop']} onClick={()=> setHeadeMostrarFormulario(false)} aria-hidden="true" />}
                </nav>
                {/*<div className='dados-user'>
                    <Link to='Dashboard' className=''>
                        <img 
                            src={imgUser} 
                            alt="Imagem do Usuario" 
                            style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%', // Para uma imagem circular
                                objectFit: 'cover', // Para ajustar a imagem sem distorção
                                marginRight: '10px' // Espaçamento à direita
                            }}
      />
                    </Link>
                </div>*/}
            </div>

        </header>
        
        
    )
}
